import React, { useEffect, useState } from "react";
import { DayPicker, getDefaultClassNames } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { ptBR } from "react-day-picker/locale";
import IconCalendar from "../assets/calendario.png";
import api from "../services/api";

const CardCalendar = () => {
  const [selected, setSelected] = useState();
  const [reminderDays, setReminderDays] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentMonth, setCurrentMonth] = useState(new Date());

  useEffect(() => {
    const fetchReminderDays = async () => {
      try {
        const month = currentMonth.getMonth() + 1;
        const year = currentMonth.getFullYear();
        console.log("year: ", year);
        const response = await api.get(`/calendar/${month}?year=${year}`);
        setReminderDays(response.data);
      } catch (error) {
        console.error("Erro ao obter dados do calendário: ", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchReminderDays();
  }, [currentMonth]);

  const today = new Date();

  const customLocale = {
    ...ptBR,
    localize: {
      ...ptBR.localize,
      day: (day) => ["D", "S", "T", "Q", "Q", "S", "S"][day],
    },
  };

  const modifiers = {
    today: today,
    reminder: reminderDays.map((item) => new Date(item.createdAt)),
  };

  const defaultClassNames = getDefaultClassNames();

  return (
    <div className="col-span-2 lg:col-span-3 md:mt-2 lg:mt-0 lg:ml-4 rounded-lg overflow-auto bg-[#F2F2F2] py-2 md:py-4 px-4 lg:px-2">
      <div className="max-w-[250px] mx-auto">
        <div className="flex items-center mb-4">
          <img
            src={IconCalendar}
            alt="Ícone de calendário"
            className="w-6 h-6 mr-2"
          />
          <h2 className="text-lg md:text-sm font-bold text-gray-700 px-4">
            Calendário
          </h2>
        </div>

        <DayPicker
          mode="single"
          classNames={{
            ...defaultClassNames,
            root: "flex flex-col items-center",
            month: "flex flex-col",
            caption_label: "text-[#2F2E41] text-[16px]",
            chevron: "fill-[#2F2E41]",
            month_grid: "bg-white flex flex-col rounded-lg px-4 py-4 my-2",
            weekdays:
              "grid grid-cols-7 gap-2 text-center text-sm text-[#2F2E41] font-bold",
            week: "grid grid-cols-7 gap-2 my-2",
            day: "w-[24px] text-center",
            day_button: "w-[16px] rounded-full h-[16px] text-[#2F2E41] text-sm",
            selected: "bg-[#D0D0D0] rounded-full",
          }}
          locale={customLocale}
          selected={selected}
          onSelect={setSelected}
          modifiers={modifiers}
          modifiersClassNames={{
            today: "bg-orange-500 text-white rounded-full",
            reminder: "bg-gray-500 text-white rounded-full",
          }}
          onMonthChange={(newMonth) => setCurrentMonth(newMonth)}
        />
        {isLoading && <p>Carregando...</p>}
        <div className="h-[300px] overflow-y-auto custom-scrollbar pr-4 -mr-4">
          {reminderDays &&
            reminderDays.map((item, index) => (
              <div
                key={index}
                className="text-white bg-primary md:text-sm lg:text-xs text-xs xl:text-sm rounded-xl py-1 px-2 mt-2 text-left"
              >
                {String(new Date(item.createdAt).getDate()).padStart(2, "0")} -{" "}
                {item.message}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default CardCalendar;
